import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

export async function exportWaterReportPDF({ motor, refs }) {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.width;
  const pageHeight = pdf.internal.pageSize.height;
  let yPosition = 20;

  pdf.setFontSize(18);
  pdf.setFont('Helvetica', 'bold');
  pdf.text(`Rapport de consommation d'eau - ${motor.name || ''}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 8;

  pdf.setFontSize(11);
  pdf.setFont('Helvetica', 'normal');
  pdf.text(`Généré le ${new Date().toLocaleDateString('fr-FR')}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 12;

  for (let i = 0; i < refs.length; i++) {
    const el = refs[i]?.current;
    if (!el) continue;

    const canvas = await html2canvas(el, { scale: 2 });
    const imgData = canvas.toDataURL('image/png', 1.0);
    const imgHeight = (canvas.height * (pageWidth - 20)) / canvas.width;

    if (yPosition + imgHeight > pageHeight - 15) {
      pdf.addPage();
      yPosition = 20;
    }

    pdf.addImage(imgData, 'PNG', 10, yPosition, pageWidth - 20, imgHeight, undefined, 'FAST');
    yPosition += imgHeight + 12;
  }

  pdf.save(`rapport-eau-${motor.name || 'compteur'}.pdf`);
}

export function exportWaterReportExcel({ motor, unitLabel, sheets }) {
  const workbook = XLSX.utils.book_new();

  sheets.forEach(({ name, data }) => {
    const rows = [
      [`Volume (${unitLabel})`],
      [],
      ['Période', `Volume (${unitLabel})`],
      ...data.map((item) => [item.name, item.Volume]),
    ];
    const sheet = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, sheet, name);
  });

  XLSX.writeFile(workbook, `rapport-eau-${motor.name || 'compteur'}.xlsx`);
}